import { Layout } from "@Components/Layout";
import ContactUs from "@Components/Pages/Pre-Footer/Contact-Us";

const ContactUsPage = () => {
  return (
    <Layout>
      <ContactUs />
    </Layout>
  );
};
export default ContactUsPage;
